<template>
  <v-container grid-list-md text-center>
    <v-window v-model="step">
      <!-- Already in queue -->
      <v-window-item :value="0">
        <v-card class="mx-auto" elevation="0">
          <h2 class="text-xs-center">
            {{ this.getConfigItem("ALREADYQUEUED_TEXT") }}
          </h2>
          <h3 class="text-xs-center">
            {{ this.getConfigItem("ALREADYQUEUEDSUB_TEXT") }}
          </h3>
          <br />
          <v-row row wrap>
            <v-row xs12 class="text-xs-center">
              <v-col>
                <v-btn
                  color="info"
                  :style="[
                    { color: INFO_COLOUR_TEXT },
                    { 'background-color': BTN_BACKGROUND_COLOUR },
                  ]"
                  @click="$root.backToHome()"
                  >{{ this.getConfigItem("BTN_BACK_TEXT") }}</v-btn
                >
              </v-col>
            </v-row>
          </v-row>
        </v-card>
      </v-window-item>
      <!--BOOKING ID-->
      <v-window-item :value="1">
        <v-card class="mx-auto" elevation="0">
          <h2 class="text-xs-center">
            {{ this.getConfigItem("WHAT_BOOKINGID_TEXT") }}
          </h2>
          <br />
          <v-form
            ref="bookingIdForm"
            v-model="isFormValid"
            lazy-validation
            @submit.prevent="confirmBookingId()"
            id="confirmBookingIdForm"
          >
            <v-text-field
              autofocus
              v-model="bookingId"
              type="text"
              :label="PHOLDER_INPUTHERE_TEXT"
              required
              :rules="bookingIdRules"
            ></v-text-field>
            <v-row row wrap>
              <v-row xs12 class="text-xs-center">
                <v-col>
                  <v-btn
                    color="info"
                    :style="{ color: INFO_COLOUR_TEXT }"
                    @click="$root.backToHome()"
                    >{{ this.getConfigItem("BTN_BACK_TEXT") }}</v-btn
                  >
                </v-col>
                <v-col>
                  <v-btn
                    type="submit"
                    color="secondary"
                    :style="{ color: SECONDARY_COLOUR_TEXT }"
                    >{{ this.getConfigItem("BTN_CONTINUE_TEXT") }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-row>
          </v-form>
        </v-card>
      </v-window-item>

      <!--APPOINTMENTS-->
      <v-window-item :value="2">
        <!--<v-container grid-list-md text-xs-center>-->
        <v-card
          class="mx-auto"
          elevation="0"
          ref="appointmentCheckinScreen"
          text-xs-center
        >
          <section v-if="firstAppointment() == null">
            <v-row row wrap text-xs-center>
              <v-col xs12>
                <h1>{{ this.getConfigItem("CHECKIN_THANKS_TEXT") }}</h1>
                {{ this.getConfigItem("WAIT_FOR_ADVISOR_TEXT") }}<br />
                <br />
              </v-col>
            </v-row>

            <v-row>
              <v-col xs12 v-if="bookingUrl != ''">
                <v-btn
                  color="secondary"
                  :style="{ color: SECONDARY_COLOUR_TEXT }"
                  class="main-menu-btn"
                  v-on:click="bookAppointment()"
                  >{{ this.getConfigItem("BOOK_APPOINTMENT_TEXT") }}</v-btn
                >
                <br />
                <br />
              </v-col>
            </v-row>

            <v-row>
              <v-col xs12>
                <v-btn
                  color="info"
                  :style="{ color: INFO_COLOUR_TEXT }"
                  class="main-menu-btn"
                  v-on:click="$root.backToHome()"
                  >{{ this.getConfigItem("BTN_MAINMENU_TEXT") }}</v-btn
                >
              </v-col>
            </v-row>
          </section>
          <section v-else>
            <v-row row wrap text-xs-center>
              <v-col xs12>
                <h1>{{ this.getConfigItem("APPOINTMENT_DETAILS_TEXT") }}</h1>
                <br />
                <br />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col xs6 class="text-right">{{
                this.getConfigItem("BOOKING_NUMBER_TEXT")
              }}</v-col>
              <v-col xs6 class="text-left" style="padding-left: 8px">{{
                firstAppointment().CaseId
              }}</v-col>
            </v-row>

            <v-row dense>
              <v-col xs6 class="text-right">{{
                this.getConfigItem("APT_DATE_TEXT")
              }}</v-col>
              <v-col xs6 class="text-left" style="padding-left: 8px">{{
                firstAppointment().AppointmentDate | getDateOnly
              }}</v-col>
            </v-row>

            <v-row dense>
              <v-col xs6 class="text-right">{{
                this.getConfigItem("APT_TIME_TEXT")
              }}</v-col>
              <v-col xs6 class="text-left" style="padding-left: 8px">{{
                firstAppointment().AppointmentDate | getTimeOnly
              }}</v-col>
            </v-row>

            <v-row dense>
              <v-col xs6 class="text-right"
                >{{ this.getConfigItem("APT_LOCATION_TEXT") }}
              </v-col>
              <v-col xs6 class="text-left" style="padding-left: 8px">{{
                firstAppointment().UnitName
              }}</v-col>
            </v-row>
            <v-spacer></v-spacer>

            <div class="d-flex justify-center flex-wrap">
              <v-btn
                class="ma-3"
                color="info"
                :style="{ color: INFO_COLOUR_TEXT }"
                @click="$root.backToHome()"
                >{{ this.getConfigItem("BTN_BACK_TEXT") }}
              </v-btn>
              <v-btn
                class="ma-3"
                color="primary"
                :style="{ color: PRIMARY_COLOUR_TEXT }"
                @click="appointmentCheckIn()"
                >{{ this.getConfigItem("BTN_CHECKIN_TEXT") }}
              </v-btn>
            </div>
          </section>
        </v-card>
        <!--</v-container>-->
      </v-window-item>
    </v-window>
  </v-container>
</template>

<script>
import cookieMixin from "@/mixins/cookieMixin";
import configAliasMixin from "@/mixins/configAliasMixin";
import utilMixin from "@/mixins/utilMixin";
import axios from "axios";
import { mapGetters } from "vuex";
import { helper } from "@/helper";

export default {
  mixins: [cookieMixin, configAliasMixin, utilMixin],
  data: function () {
    return {
      isFormValid: false,
      bookingId: "",
      bookingIdRules: [(v) => !!v || this.getConfigItem("REQUIRED_TEXT")],
      step: 2,
      appointments: [],
    };
  },
  computed: {
    ...mapGetters([
      "isConfigLoaded",
      "isShowLoadingMessage",
      "getConfigItemNestedObjectValue",
      "getConfigItem",
    ]),
    bookingUrl() {
      return this.getConfigItemNestedObjectValue("BOOKING_URL", "url");
    },
    PHOLDER_INPUTHERE_TEXT() {
      return this.getConfigItem("PHOLDER_INPUTHERE_TEXT");
    },
  },
  mounted: function () {
    let caseCookie = helper.getCaseCookie();
    if (process.env.VUE_APP_ISDEBUGGING)
      console.log("Appointment Check-in Mounted. caseCookie:", caseCookie);

    if (caseCookie) {
      // already got a case, show already queued message
      this.step = 0;
      return;
    }

    //this.$root.showLoading();
    let userCookie = helper.getUserCookie();
    //debugger;
    if (process.env.VUE_APP_ISDEBUGGING)
      console.log("Appointment Check-in Mounted. UserCookie:", userCookie);

    if (userCookie != null) {
      //if payload doesn't contain student id, ask for booking id (caseId) and then check for /Cases/{id} lookup
      if (!userCookie.userName) {
        this.step = 1;
        return;
      }

      let params = { PersonalId: userCookie.userName };

      this.checkForAppointment(params);
    }
  },
  methods: {
    confirmBookingId() {
      let userCookie = helper.getUserCookie();
      if (!userCookie.userName && !this.$refs.bookingIdForm.validate()) {
        return;
      }

      let params = { CaseId: this.bookingId };
      this.checkForAppointment(params);
    },
    checkForAppointment(params) {
      let today = new Date();
      let tomorrow = new Date();
      tomorrow.setDate(today.getDate() + 1);

      params.Status = 255;
      params.DueAfterDate = this.dateToYMD(today);
      params.DueBeforeDate = this.dateToYMD(tomorrow);
      params.CurrentEntityStatusDesc = "Expected";

      axios
        .get("/Appointments", {
          params: params,
        })
        .then((response) => {
          this.appointments =
            response.data.count > 0
              ? response.data.appointmentResults.filter((appointment) => {
                  return appointment.CurrentEntityStatus === 0;
                })
              : null;
          this.step = 2;
        });

      //this.service.callGetService(this, "/Appointments", {
      //    params: params
      //}, (response) => {
      //    this.appointments = response.data.count > 0 ? response.data.appointmentResults : null;
      //    this.step = 2;
      //}, null, "checking appointments...");
    },
    appointmentCheckIn() {
      this.$root.showLoading();

      let userCookie = helper.getUserCookie();
      let caseId = this.firstAppointment().CaseId;

      axios
        .post("/Appointments/Checkin", {
          CaseId: caseId,
          PersonalId: userCookie.userName,
        })
        .then(
          (response) => {
            helper.setCaseCookie(
              response.data.CaseId,
              true,
              null,
              null,
              this.getConfigItem("DATA_RETENTION_PERIOD")
            );
            this.$router.push("EnqueueInfo");
          },
          (error) => {
            console.log(error);
            helper.deleteCaseCookie();
            let errorMessage = "Booking not found!";
            if (
              error &&
              error.response &&
              error.response.data &&
              error.response.data.Message
            ) {
              errorMessage = error.response.data.Message;
            }

            let errorInfo = "";

            switch (errorMessage) {
              case "Too Early":
                errorInfo = this.getConfigItem("APT_ERR_TOO_EARLY_TEXT");
                break;
              case "Too Late":
                errorInfo = this.getConfigItem("APT_ERR_TOO_LATE_TEXT");
                break;
              case "Late - refer to reception/concierge":
                errorInfo = this.getConfigItem("APT_ERR_LATE_TEXT");
                break;
              case "Refer to reception/concierge":
                errorInfo = this.getConfigItem("APT_ERR_REFER_TEXT");
                break;
              default:
                errorInfo =
                  this.getConfigItem("APT_ERR_DEFAULT1_TEXT") +
                  errorMessage +
                  this.getConfigItem("APT_ERR_DEFAULT2_TEXT");
                break;
            }

            this.$root.showError(errorMessage, errorInfo);
          }
        )
        .then(() => {
          this.$root.hideLoading();
        });
    },
    bookAppointment() {
      if (this.getConfigItemNestedObjectValue("BOOKING_URL", "url")) {
        window.open(
          this.getConfigItemNestedObjectValue("BOOKING_URL", "url"),
          "_blank"
        );
      }
    },
    firstAppointment() {
      if (this.appointments && this.appointments.length > 0) {
        return this.appointments[0];
      }

      return null;
    },
  },
};
</script>
